import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import GooglePlayBadge from '../components/GooglePlayBadge';
import SamsungBadge from '../components/SamsungBadge';
import './Home.css';
import iconBolt from '../components/icons/bolt_24dp.svg';
import iconLink from '../components/icons/link_24dp.svg';
import iconTune from '../components/icons/tune_24dp.svg';

const Home = () => {
  const { t } = useTranslation();
  
  return (
    <div className="home">
      <Helmet>
        <title>{t('home.title')}</title>
        <meta name="description" content={t('home.description')} />
      </Helmet>
      
      <section>
        <div className='hero container'>
          <div className='hero-text'>
            <h1>{t('home.title')}</h1>
            <p>{t('home.description')}</p>
            <h4>{t('common.current')}</h4>
            <div className='badges-container'>
              <GooglePlayBadge  packageName="com.bong.barcode2sheetsv2" />
            </div>
            <h4>{t('common.legacy')}</h4>

            <div className='badges-container'>
              <GooglePlayBadge packageName="com.bong.barcode2sheets" /> 
              {/*<SamsungBadge packageName="com.bong.barcode2sheets" />*/}
            </div>
                        
            <div className='hero-diff'>
              <a href="#comparision">{t('home.version_comparision')}</a> 
            </div>
          </div>

          <div className='hero-image'>
            <img 
              src="/common/app-screenshot.png" 
              alt="Barcode To Sheets App Screenshot" 
              className="app-screenshot" 
              style={{display: "block"}}
            />
          </div>
        </div>
          
      </section>

      <section className='features'>
        
        <div className='container'>
          <h2>{t('home.key_features')}</h2>
          <div className="features-container">
            <div className="feature-card">
              <img src={iconLink} alt={t('home.features.integration')}/>
              <h3>{t('home.features.integration')}</h3>
              <p>{t('home.features.integration_desc')}</p>
            </div>
            <div className="feature-card">
              <img src={iconBolt} alt={t('home.features.scanning')}/>
              <h3>{t('home.features.scanning')}</h3>
              <p>{t('home.features.scanning_desc')}</p>
            </div>
            <div className="feature-card">
              <img src={iconTune} alt={t('home.features.customizable')}/>
              <h3>{t('home.features.customizable')}</h3>
              <p>{t('home.features.customizable_desc')}</p>
            </div>
          </div>
        </div>
      </section>


      <section id="comparision" className="comparison">
        
        <div className='container'>
          <h2>{t('home.version_comparision')}</h2>
          <p>{t('home.version_comparision_summary')}</p>
          <table>
              <thead>
                <tr>
                  <th>{t('home.feature')}</th>
                  <th>{t('common.current')}</th>
                  <th>{t('common.legacy')}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                    <td>{t('home.version_comparisions.feature1')}</td>
                    <td>✓</td>
                    <td>&#45;<br/>{t('home.single_sheet_only')}</td>
                </tr>
                <tr>
                    <td>{t('home.version_comparisions.feature2')}</td>
                    <td>✓</td>
                    <td>&#45;</td>
                </tr>
                <tr>
                    <td>{t('home.version_comparisions.feature3')}</td>
                    <td>✓</td>
                    <td>&#45;</td>
                </tr>
                <tr>
                    <td>{t('home.version_comparisions.feature4')}</td>
                    <td>✓</td>
                    <td>&#45;<br/>{t('home.google_sheets_only')}</td>
                </tr>
              </tbody>
          </table>
          </div>
      </section>


    </div>
  );
};

export default Home;